// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"8fe07f99","274":"886d277f","294":"8fe07f99","597":"a1efdf66","861":"8fe07f99","879":"5615f2ca"}[chunkId] + ".css";
};